import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

interface mutateProps { id: string, data: FieldValues }

const mutateUpdateQualityChecklist = async ({ id, data }: mutateProps) => {
  return await axiosAuth.put(`${QUALITY_CHECKLIST_API}/${id}`, data);
};

const useUpdateQualityChecklistMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateQualityChecklist,
    ...queryParams,
  });

export default useUpdateQualityChecklistMutation;
